import React from "react";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import InsightsIcon from "@mui/icons-material/Insights";
import PeopleIcon from "@mui/icons-material/People";
import QrCodeIcon from "@mui/icons-material/QrCode";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import heroImage from "../../assets/home/heroimage.svg";

import phoneMockup from "../../assets/home/phone mockup.svg";
import videoIphone from "../../assets/home/iphone-16-pro.mp4";
import StarIcon from '@mui/icons-material/Star';
import bggif from "../../assets/home/bg.gif";


// ADD new
import step1 from "../../assets/home/step1.png";
import step2 from "../../assets/home/step2.png";
import step3 from "../../assets/home/step3.png";
import step4 from "../../assets/home/step4.png";

// Trusted partners
const trustedPartners = [
  { src: require("../../assets/logo/lankapaylogo.png"), alt: "Partner 1", width: 120, height: 60 },
  { src: require("../../assets/logo/govpaylogo.png"), alt: "Partner 2", width: 120, height: 60 },
  { src: require("../../assets/logo/sampath.png"), alt: "Partner 3", width: 120, height: 60 },
];

// Why Moipay Features
const features = [
  { icon: <QrCodeIcon sx={{ fontSize: 36 }} />, title: "QR Payments", description: "Accept instant cashless payments with MoiPay QR codes. Customers can make secure payments using their digital wallets or linked bank accounts, ensuring faster and more convenient transactions." },
  { icon: <AssessmentIcon sx={{ fontSize: 36 }} />, title: "Credit Reports", description: "Access credit reports based on your transaction history. Understand your financial performance, build credibility, and use the insights for bank loans or business growth." },
  { icon: <PeopleIcon sx={{ fontSize: 36 }} />, title: "Payees with Friends", description: "Send or receive funds easily with friends or partners. Split bills, settle payments, or pool funds directly through the app." },
  { icon: <ReceiptIcon sx={{ fontSize: 36 }} />, title: "Utility Payment", description: "Pay or collect utility bills directly through MoiPay. Simplify your daily transactions and offer multiple services from a single platform." },
  { icon: <InsightsIcon sx={{ fontSize: 36 }} />, title: "Insights & Analytics", description: "Track sales, peak hours, top-selling products, and customer trends with real-time dashboards. Gain clear, actionable insights to make smarter business decisions." },
  { icon: <SwapHorizIcon sx={{ fontSize: 36 }} />, title: "Effective & Seamless Transactions", description: "Enjoy fast, secure, and fully recorded digital transactions. Receive instant receipts and earn loyalty points, while benefiting from support for multiple locations and integrated POS systems for seamless management." },
];

// How it works steps

/*const fadeSlideUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};*/






/*const howItWorksSteps = [
  { step: "Step 1", title: "Easy Sign Up", description: "Create your account in seconds and unlock all the features waiting for you. Start exploring today!", image: img1 },
  { step: "Step 2", title: "Link Your Bank Account", description: "Connect your bank account in just a few clicks for fast, secure access to all your financial features.", image: img2 },
  { step: "Step 3", title: "Begin Your Transactions", description: "Seamless, secure transactions at your fingertips. Start now and simplify your financial journey.", image: img3 },
];
*/
const MainContentSection = () => {
  return (
    <Box sx={{ width: "100%", bgcolor: "#000", color: "#fff" }}>
      {/* Hero Section */}
<Box
  sx={{
    position: "relative",
    width: "100%",
    pt: 12,
    pb: 14,
    px: { xs: 4, md: 8 },
    overflow: "hidden",
    background: "radial-gradient(50% 50% at 50% 0%, rgba(94,176,239,0.5) 0%, rgba(0,0,0,0) 100%)",
    maxWidth: "1440px",      // ✅ Keeps layout centered
    mx: "auto",              // ✅ Centers hero content
}}
>

  {/* Hero Image (Hide below 1440px) */}
  <Box
    component="img"
    src={heroImage}
    alt="Hero"
    sx={{
      position: "absolute",
      top: 0,
      right: "-10%",
      width: "60%",
      height: "100%",
      objectFit: "contain",
      opacity: 0.95,
      zIndex: 0,
      display: { xs: "none", lg: "block", xl: "block" }, // ✅ Visible only above 1440px
    }}
  />

  <Grid container spacing={6} alignItems="center" sx={{ position: "relative", zIndex: 1 }}>
    <Grid item xs={12} md={6}>
      <Stack spacing={6}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: 40, md: 72 },
            fontWeight: 700,
            lineHeight: 1.1,
            background: "linear-gradient(176deg, rgba(255,255,255,1) 0%, rgba(113,113,122,1) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: "3px",
          }}
        >
          Building a Smart Fintech <br />
          For a Digital Tomorrow
        </Typography>

        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 500,
            color: "#a1a1aa",
            maxWidth: 600,
            lineHeight: 1.6,
          }}
        >
          MoiPay is a smart, secure, all-in-one digital payment platform designed to simplify money management for individuals and businesses.
        </Typography>

        <Button
          variant="contained"


  onClick={() => {
    document
      .getElementById("download-section")
      ?.scrollIntoView({ behavior: "smooth" });
  }}



          sx={{
            width:"190px",
            height:"40px",
            bgcolor: "#09090b",
            borderRadius: "9999px",
            px: 2,
            py: 2.5,
            color:" #A1A1AA",
            fontSize: 20,
            fontWeight: 500,
            lineHeight: "20px",
            textTransform: "none",
            boxShadow: "0px 0px 0px 0.2px #22D3E0",
            "&:hover": { bgcolor: "#18181b" },
          }}
        >
          Download Now
        </Button>

        <Stack spacing={3}>
          <Typography variant="h6" sx={{ fontSize: 21, color: "#fff" }}>
            Trusted Partners
          </Typography>

          <Stack direction="row" spacing={3}>
            {trustedPartners.map((partner, i) => (
              <Box
                key={i}
                component="img"
                src={partner.src}
                alt={partner.alt}
                sx={{
                  width: partner.width,
                  height: partner.height,
                  objectFit: "contain",
                  opacity: 0.9,
                }}
              />
            ))}
          </Stack>
        </Stack>

      </Stack>
    </Grid>
  </Grid>
</Box>

      {/* Why Moipay Section */}
<Box
  sx={{
    px: { xs: 4, md: 10 },
    py: 12,
    maxWidth: 1440,
    mx: "auto",
    bgcolor: "#000",
    color: "#fff",
  }}
>
  {/* Header Row: Title + Paragraph side by side */}
  <Grid
    container
     spacing={6}
    alignItems="center"
    sx={{ mb: { xs: 8, md: 12 } }}
  >
    <Grid item xs={12} md={6}>
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: 36, md: 48 },
          fontWeight: 800,
          lineHeight: 1.2,
          background:
            "linear-gradient(177deg, rgba(255,255,255,1) 0%, rgba(113,113,122,1) 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          mt:-5,
        }}
      >
        Why MoiPay ?
      </Typography>
    </Grid>

    <Grid item xs={12} md={6}>
      <Typography
        sx={{
          fontSize: { xs: 16, md: 18 },
          color: "rgba(161,161,170,0.8)",
          lineHeight: 1.2,
          maxWidth: 850,
        }}
      >
       MoiPay is a cutting-edge fintech solution designed to simplify financial tasks for Sri Lankans. 
       Whether it's managing daily transactions, paying bills, or accessing services from multiple banks 
       through a single platform, MoiPay empowers users with intuitive, secure, and fast tools to 
       take control of their financial lives. Built on convenience and trust, MoiPay bridges modern technology 
       with real-world financial needs.
      </Typography>
    </Grid>
  </Grid>

  {/* 3-Column Layout: 2 columns of features + 1 column of video */}
  <Grid container spacing={6} alignItems="flex-start">
    {/* Column 1: First 3 features */}
    <Grid item xs={12} md={4}>
      <Stack spacing={5}>
        {features.slice(0, 3).map((feature, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                bgcolor: "rgba(255,255,255,0.08)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffffff",
                flexShrink: 0,
              }}
            >
              {feature.icon}
            </Box>
            <Stack spacing={0.5}>
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#f5f5f5",
                }}
              >
                {feature.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: 15,
                  lineHeight: 1.6,
                  color: "rgba(255,255,255,0.7)",
                  maxWidth: 320,
                }}
              >
                {feature.description}
              </Typography>
            </Stack>
          </Box>
        ))}
      </Stack>
    </Grid>

    {/* Column 2: Next 3 features */}
    <Grid item xs={12} md={4}>
      <Stack spacing={5}>
        {features.slice(3, 6).map((feature, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                bgcolor: "rgba(255,255,255,0.08)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffffff",
                flexShrink: 0,
              }}
            >
              {feature.icon}
            </Box>
            <Stack spacing={0.5}>
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#f5f5f5",
                }}
              >
                {feature.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: 15,
                  lineHeight: 1.6,
                  color: "rgba(255,255,255,0.7)",
                  maxWidth: 320,
                }}
              >
                {feature.description}
              </Typography>
            </Stack>
          </Box>
        ))}
      </Stack>
    </Grid>

    {/* Column 3: Video */}
    <Grid
      item
      xs={12}
      md={4}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        component="video"
        src={videoIphone}
        autoPlay
        loop
        muted
        playsInline
        sx={{
           width: "110%",
          maxWidth: 400,
          borderRadius: 4,
          objectFit: "contain",
          
        }}
      />
    </Grid>
  </Grid>
</Box>

      {/* All-in-One Solution Section */}
<Box 
  sx={{
    position: "relative",
    py: 12,
    px: { xs: 4, md: 8 },
    borderRadius: 2,
     backgroundImage: `url(${bggif})`,
    // overflow: "hidden",// replace with your actual GIF path
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <Grid container spacing={20} alignItems="center">

    <Grid
      item
      xs={12}
      md={6}
      sx={{
        display: "flex",
        justifyContent: { xs: "center", md: "right" },
        alignItems: "center",
      }}
    >
      <Box
        component="img"
        src={phoneMockup}
        alt="All in one solution"
        sx={{ width: 600, maxWidth: 500, borderRadius: 4 }}
      />
    </Grid>
    {/* Left Column: Text + Trusted */}
    <Grid item xs={12} md={6}>
      <Stack spacing={3} sx={{ maxWidth: 500 }}>
        <Typography
          variant="h3"
          sx={{
            fontSize: 40,
            fontWeight: 900,
            letterSpacing: "2.8px",
          }}
        >
          <Box component="span" sx={{ color: "#fff" }}>
            Your{" "}
          </Box>
          <Box
            component="span"
            sx={{ color: "#fed449", fontFamily: "cursive" }}
          >
            All-in-one
          </Box>
          <Box component="span" sx={{ color: "#fff" }}>
            {" "}Financial Solution
          </Box>
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: 21,
            color: "#ccc2f7",
            lineHeight: 1.5,
          }}
        >
          Take the first step towards smarter, simpler, and more secure
          financial management
        </Typography>

        <Stack spacing={2}>
          <Typography variant="h6" sx={{ fontSize: 21, color: "#fff" }}>
            Trusted by{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              50k+
            </Box>{" "}
            customers
          </Typography>
          <Stack direction="row" spacing={0.5}>
            {[1, 2, 3, 4, 5].map((star) => (
              <StarIcon
                key={star}
                sx={{ fontSize: 22, color: "#fbbf24" }}
              />
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Grid>

    {/* Right Column: Phone Mockup Image */}
    
  </Grid>
</Box>

      {/* How It Works Section */}
{/* How It Works Section */}
<Stack spacing={5} sx={{ px: { xs: 4, md: 8 }, py: 12, maxWidth: 1440, mx: "auto" }}>
  <Typography
    variant="h2"
    sx={{
      fontSize: 48,
      fontWeight: 700,
      background: "linear-gradient(177deg, rgba(255,255,255,1) 0%, rgba(113,113,122,1) 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      letterSpacing: "-1.2px",
    }}
  >
    How MoiPay works?
  </Typography>

<Grid container spacing={10}>

  {/* STEP 01 */}
  <Grid
  container
  spacing={20}
  alignItems="center"
  sx={{
    flexDirection: {
      xs: "column",
      lg: "row"
    },
    "@media (max-width:1388px) and (min-width:1200px)": {
      flexDirection: "column"
    }
  }}
>
    
    {/* IMAGE LEFT (UNDER 1388px) */}
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        order: { xs: 1, lg: 2 }
      }}
    >
      <Box
        component="img"
        src={step1}
        sx={{ width: "100%", maxWidth: 400, mx: "auto", display: "block" }}
      />
    </Grid>

    {/* TEXT RIGHT */}
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        order: { xs: 2, lg: 1 }
      }}
    >
      <Stack spacing={2}>
        <Typography sx={{ color: "#a1a1aa", fontSize: 16 }}>
          Step 01
        </Typography>

        <Typography sx={{ fontSize: 28, fontWeight: 700 }}>
          Sign in / Sign up
        </Typography>

        <Box
          sx={{
            background: "linear-gradient(145deg, rgba(255,255,255,0.08), rgba(255,255,255,0.02))",
            p: 2,
            borderRadius: 3,
            maxWidth: 700,
          }}
        >
          <Typography sx={{ color: "#d4d4d8", fontSize: 28 }}>
            Create your MoiPay account using your email or mobile number.
            Existing users can securely sign in.
          </Typography>
        </Box>
      </Stack>
    </Grid>
  </Grid>


  {/* STEP 02 */}
  <Grid container spacing={20} alignItems="center">

    {/* IMAGE */}
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        order: { xs: 1, lg: 1 }
      }}
    >
      <Box
        component="img"
        src={step2}
        sx={{ width: "100%", maxWidth: 400, mx: "auto", display: "block" }}
      />
    </Grid>

    {/* TEXT */}
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        order: { xs: 2, lg: 2 }
      }}
    >
      <Stack spacing={2}>
        <Typography sx={{ color: "#a1a1aa", fontSize: 16 }}>
          Step 02
        </Typography>

        <Typography sx={{ fontSize: 28, fontWeight: 700 }}>
          Account Verification
        </Typography>

        <Box sx={{ background: "rgba(255,255,255,0.05)", p: 3, borderRadius: 3 ,maxWidth: 700 }}>
          <Typography sx={{ color: "#d4d4d8", fontSize: 28 }}>
            Complete the KYC process and verify your identity to unlock all features.
          </Typography>
        </Box>
      </Stack>
    </Grid>
  </Grid>


  {/* STEP 03 */}
  <Grid container spacing={20} alignItems="center">

    {/* IMAGE LEFT UNDER 1388 */}
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        order: { xs: 1, lg: 2 }
      }}
    >
      <Box
        component="img"
        src={step3}
        sx={{ width: "100%", maxWidth: 400, mx: "auto", display: "block" }}
      />
    </Grid>

    {/* TEXT RIGHT */}
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        order: { xs: 2, lg: 1 }
      }}
    >
      <Stack spacing={2}>
        <Typography sx={{ color: "#a1a1aa", fontSize: 16 }}>
          Step 03
        </Typography>

        <Typography sx={{ fontSize: 28, fontWeight: 700 }}>
          Login to the Home Page
        </Typography>

        <Box sx={{ background: "rgba(255,255,255,0.05)", p: 3, borderRadius: 3 ,maxWidth: 700 }}>
          <Typography sx={{ color: "#d4d4d8", fontSize: 28 }}>
            Access your dashboard to monitor balance, transactions, and quick actions.
          </Typography>
        </Box>
      </Stack>
    </Grid>
  </Grid>


  {/* STEP 04 */}
  <Grid container spacing={6} alignItems="center">

    {/* IMAGE */}
    <Grid item xs={12} md={6}>
      <Box
        component="img"
        src={step4}
        sx={{ width: "100%", maxWidth: 400, mx: "auto", display: "block" }}
      />
    </Grid>

    {/* TEXT */}
    <Grid item xs={12} md={6}>
      <Stack spacing={2}>
        <Typography sx={{ color: "#a1a1aa", fontSize: 16 }}>
          Step 04
        </Typography>

        <Typography sx={{ fontSize: 28, fontWeight: 700 }}>
          Set Up Your Profile & Wallet
        </Typography>

        <Box sx={{ background: "rgba(255,255,255,0.05)", p: 3, borderRadius: 3, maxWidth: 700 }}>
          <Typography sx={{ color: "#d4d4d8", fontSize: 28 }}>
            Complete your profile and activate your wallet to start using features.
          </Typography>
        </Box>
      </Stack>
    </Grid>

  </Grid>

</Grid>
</Stack>

    </Box>
  );
};

export default MainContentSection;


